exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../../node_modules/postcss-loader/index.js!../../../assets/typography.pcss"), undefined);

// module
exports.push([module.id, ".TableName__tHead_first___1uuny{background-color:#004f5c;padding:.5em .75em;color:#fff;text-align:left;max-width:400px;font-size:13px;line-height:14px;border:0;font-weight:700}", ""]);

// exports
exports.locals = {
	"tHead_first": "TableName__tHead_first___1uuny " + require("-!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../../node_modules/postcss-loader/index.js!../../../assets/typography.pcss").locals["bodyText"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/Rankia/Components/TableName/TableName.pcss
// module id = 860
// module chunks = 0